import {
  DeleteOutlined,
  EditOutlined,
  FolderViewOutlined,
} from '@ant-design/icons';
import { COLOR_TOOLTIP } from '@constants';
import { Button, Tooltip } from 'antd';
import { TableProps } from 'antd/lib';
import { TGetStoresMasterTable } from 'types/types';
import { STORE_PAGE_CONSTANT } from './constant';

const { TABLE_KEY } = STORE_PAGE_CONSTANT;

const renderCodeName = (code: string, name: string) => {
  return code + `${name ? `_${name}` : ''}`;
};

export const getColumns = ({
  translate,
  disableBtnOther,
  handleOpenModalDelete,
  handleOpenModalDetail,
  handleOpenModalUpdate,
}: {
  translate: any;
  disableBtnOther: boolean;
  handleOpenModalDelete: (record: TGetStoresMasterTable) => void;
  handleOpenModalDetail: (record: TGetStoresMasterTable) => void;
  handleOpenModalUpdate: (record: TGetStoresMasterTable) => void;
}): TableProps<TGetStoresMasterTable>['columns'] => {
  return [
    {
      title: translate('STORE_PAGE.NO_COL'),
      key: TABLE_KEY.KEY,
      dataIndex: TABLE_KEY.KEY,
      align: 'center',
      width: 80,
    },
    {
      title: translate('STORE_PAGE.COMPANY_COL'),
      key: TABLE_KEY.COMPANY_CODE,
      dataIndex: TABLE_KEY.COMPANY_CODE,
      align: 'center',
      width: 120,
      render: (value, record) => {
        if (record) {
          const codeName = renderCodeName(value, record.companyName);
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={codeName}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                }}
              >
                {codeName}
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: translate('STORE_PAGE.AREA_COL'),
      key: TABLE_KEY.AREA_CODE,
      dataIndex: TABLE_KEY.AREA_CODE,
      align: 'center',
      width: 120,
      render: (value, record) => {
        if (record) {
          const codeName = renderCodeName(value, record.sectorName);
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={codeName}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                }}
              >
                {codeName}
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: translate('STORE_PAGE.STORE_COL'),
      key: TABLE_KEY.STORE_CODE,
      dataIndex: TABLE_KEY.STORE_CODE,
      align: 'center',
      width: 120,
      render: (value, record) => {
        if (record) {
          const codeName = renderCodeName(value, record.storeName);
          return (
            <div className="list-page_ellipsis">
              <Tooltip
                color="white"
                overlayClassName="common_custom-tooltip"
                title={codeName}
                overlayInnerStyle={{
                  color: COLOR_TOOLTIP,
                  whiteSpace: 'pre-wrap',
                }}
              >
                <div style={{ whiteSpace: 'pre-wrap' }}>{codeName}</div>
              </Tooltip>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: translate('STORE_PAGE.ACTION'),
      align: 'center',
      width: 144,
      render(_, record) {
        return (
          <div className="list-page_modal-btns">
            <Button
              onClick={() => {
                handleOpenModalDetail(record);
              }}
            >
              <FolderViewOutlined
                style={{
                  fontSize: '21px',
                  color: '#344054',
                  cursor: 'pointer',
                }}
              />
            </Button>
            <Button
              disabled={disableBtnOther}
              onClick={() => {
                handleOpenModalUpdate(record);
              }}
            >
              <EditOutlined
                style={{
                  fontSize: '21px',
                  color: `${disableBtnOther ? '#99a6bb' : '#344054'}`,
                  cursor: 'pointer',
                }}
              />
            </Button>
            <Button
              disabled={disableBtnOther}
              onClick={() => {
                handleOpenModalDelete(record);
              }}
            >
              <DeleteOutlined
                style={{
                  fontSize: '21px',
                  color: `${disableBtnOther ? '#99a6bb' : '#F04438'}`,
                  cursor: 'pointer',
                }}
              />
            </Button>
          </div>
        );
      },
    },
  ];
};
